import { useWindowSize } from "@components/window-size-provider";
import useMapCmsToScreenSize from "@hooks/useMapCmsToScreenSize";
import { showInfoModal } from "@lib/showModal";
import { getWordpressVars } from "@lib/wordpressVars";
import { Button } from "antd";
import { useEffect } from "react";

interface GoogleAdsProps {
    slotId?: string;
    clientId?: string;
    modalLink?: boolean;
    displayOn?: string[];
}

const defaultProps: GoogleAdsProps = {
    displayOn: []
};

const GoogleAds = ({ slotId, clientId, modalLink = false, displayOn = [] }: GoogleAdsProps) => {
    const css: string[] = ["google-ad", "ad-area"];
    const windowDimensions = useWindowSize();
    const showAd = useMapCmsToScreenSize(windowDimensions, displayOn);
    const ads = getWordpressVars().ads;

    const pushAd = () => {
        try {
            const adsbygoogle = window.adsbygoogle
            adsbygoogle?.push({})
        } catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        if (showAd && ads) {
            let interval = setInterval(() => {
                if (window.adsbygoogle) {
                    pushAd()
                    clearInterval(interval)
                }
            }, 300)

            return () => {
                clearInterval(interval)
            }
        }
    }, [showAd, ads])

    return (
        <>
            {(showAd && ads) &&
                <section className={css.join(' ')}>
                    {modalLink
                        && <Button
                            className={`why-ads-btn`}
                            type={`link`}
                            onClick={() => showInfoModal({
                                title: "Why Do We Show Ads?",
                                content: (
                                    <p>Although <strong>COVR</strong>PRICE charges a subscription for our collection management and price guide tools, our content section is free-to-all. As such, ads allow us to monetize this part of the website so that we can continue to produce high-quality content for you. Our goal is to provide ads that may be of interest to you, so please support <strong>COVR</strong>PRICE by clicking on some of our sponsors.<br />Thank you!</p>
                                ),
                                onOk() { },
                            })}
                        >Why Ads?
                        </Button>
                    }
                    <ins className="adsbygoogle"
                        data-ad-client={clientId}
                        data-ad-slot={slotId}
                        data-ad-format="auto"
                        data-full-width-responsive="true"
                    />
                </section>
            }
        </>
    );
};

GoogleAds.defaultProps = defaultProps;

export default GoogleAds;
